import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/games/world-of-warcraft-boost/become_gold_seller_icon.webp")